<template>
  <a-alert
    message="Esse compromisso é realizado pelo robô de consulta GCPJ"
    show-icon
  />
</template>
